import * as CONST from '../ActionTypes';

const initialState = {
  token: '',
};

function qrQuery(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // qr query作成
    // -----------------
    case CONST.CREATE_QRQUERY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          token: action.payload || '',
        },
      );
    case CONST.CREATE_QRQUERY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          token: '',
        },
      );
    // -----------------
    // qr query作成
    // -----------------
    case CONST.CLEAR_QRQUERY_TOKEN:
      return Object.assign(
        {},
        state,
        {
          token: '',
        },
      );
    default:
      return state;
  }
}

export default qrQuery;
